import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-subscription-amount',
  templateUrl: './subscription-amount.component.html',
  styleUrls: ['./subscription-amount.component.scss']
})
export class SubscriptionAmountComponent implements OnInit {
  @Input() subscriptionPlan;
  @Input() cameraPlan;
  @Input() spacePlan;
  @Input() taxPercentage;
  constructor() { }

  ngOnInit() {
  }
  getTotalPrice() {
    return this.getTaxAmount() + this.getSubTotalPrice();
  }

  getSubTotalPrice() {
    const subsriptionPrice = this.subscriptionPlan && this.subscriptionPlan.new_price ? this.subscriptionPlan.new_price : 0;
    const cameraPrice = this.cameraPlan && this.cameraPlan.new_price ? this.cameraPlan.new_price : 0;
    const spacePrice = this.spacePlan && this.spacePlan.new_price ? this.spacePlan.new_price : 0;
    return subsriptionPrice + cameraPrice + spacePrice;
  }

  getTaxAmount() {
    if (this.taxPercentage && this.taxPercentage > 0) {
      const subTotalPrice = this.getSubTotalPrice();
      const taxAmount = subTotalPrice * this.taxPercentage / 100;
      return Math.round(taxAmount);
    }
    return 0;
  }

}
